import { NgModule } from '@angular/core';
import { PStatusSubLabelComponent } from './p-status-sub-label.component';
import { CommonModule } from '@angular/common';

@NgModule({
    declarations: [PStatusSubLabelComponent],
    imports: [CommonModule],
    exports: [PStatusSubLabelComponent]
})
export class PStatusSubLabelModule {}
